import axios from 'axios';

const prod = 'https://api.medway.com.br/';
const dev = 'http://127.0.0.1:3333/';

const apiDashboard = axios.create({
  baseURL: process.env.NODE_ENV === 'development' ? dev : prod,
});

export default apiDashboard;
